const COMPANY_COLORS = [
  '#2f6fed',
  '#2e9e5b',
  '#f07c1b',
  '#f4b400',
  '#8e44ad',
  '#e5484d',
  '#12a4b6',
  '#d63384',
];

export const companyColor = (index: number) => COMPANY_COLORS[index % COMPANY_COLORS.length];
